// Navigation V2 : où atterrit chaque rôle après login. Source unique de la
// route d'accueil par rôle (utilisée par LoginPage, AuthProvider, l'index /app).
import type { UserRole, Profile } from './auth';

/** Route d'accueil /app selon le rôle (fallback sans équipe). */
export function homeForRole(role?: UserRole | string | null): string {
  switch (role) {
    case 'client':      return '/app/portail';
    case 'sdr':         return '/app/ma-journee';
    case 'super_admin': return '/app/bp';       // Direction
    case 'admin':       return '/app/sante';    // CSM / Manager
    case 'csm':         return '/app/sante';    // CSM / Manager
    default:            return '/app/ma-journee';
  }
}

/** Route d'accueil selon le PROFIL complet. Les prospecteurs (role admin mais
 *  prospecting_team renseignée) atterrissent sur leur front métier, pas sur la
 *  vue manager. Marche aussi après bascule vers le vrai rôle 'sdr'. */
export function homeForProfile(profile?: Pick<Profile, 'role' | 'prospecting_team'> | null): string {
  const role = profile?.role;
  if (role === 'client') return '/app/portail';
  if (role === 'super_admin') return '/app/bp';
  if (role === 'sdr') return '/app/ma-journee';
  // Interne : le front dépend du métier, pas du rôle admin générique.
  if (profile?.prospecting_team === 'cold_call' || profile?.prospecting_team === 'gtm') return '/app/ma-journee';
  if (role === 'admin') return '/app/sante'; // admin sans équipe = manager/CSM
  return '/app/ma-journee';
}

/** Rôles autorisés à voir les vues internes (tout sauf client). */
export const INTERNAL_ROLES = ['sdr', 'gtm', 'csm', 'admin', 'super_admin'];
